var _g, _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoader(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 126,
    height: 115,
    viewBox: "0 0 126 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M111 100H15L34.2 20H91.8L111 100Z",
    fill: "black",
    fillOpacity: 0.6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 1C16.3431 1 15 2.34315 15 4V21H15C14.9999 53.2351 13.6318 84.1372 13.1587 93.8602C13.075 95.5786 14.4459 97 16.1664 97H109.834C111.554 97 112.925 95.5786 112.841 93.8602C112.368 84.1372 111 53.2351 111 21V4C111 2.34315 109.657 1 108 1H18Z",
    fill: "#ccc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M83.2904 47.4628C82.0449 37.6285 73.646 30 63.5 30C55.6454 30 48.8225 34.6028 45.7074 41.8571C39.5856 43.6914 35 49.4856 35 55.7142C35 63.5913 41.3925 69.9998 49.25 69.9998H80.6C86.8871 69.9998 92 64.8741 92 58.5713C91.9956 56.0102 91.1354 53.5244 89.5567 51.5108C87.9779 49.4973 85.7718 48.0721 83.2904 47.4628Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 0,
    y: 5,
    width: 126,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7.5,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 62.8445,
    y1: 1,
    x2: 62.8445,
    y2: 97,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0090FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#209EFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "static/media/loader.5f0f9a4c.svg";
export { ForwardRef as ReactComponent };